import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
  },

  headerContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '1.75rem',
    padding: '0 1rem',

    '& span': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '180px',
      borderRadius: '0.5rem',
      fontWeight: '600',
      fontSize: '16px',
    },
  },

  headerText: {
    '& h1': {
      fontFamily: 'Sora',
      fontWeight: '400',
      fontSize: '34px',
      lineHeight: '42px',
    },

    '& h5': {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '0',
      padding: '0',
      margin: '0',
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '16px',
      lineHeight: '22px',

      '& p': {
        padding: '0',
        margin: '0',
        marginLeft: '0.5rem',
        opacity: 0.8,
      },
    },
  },

  statusActive: {
    background: '#66BB6A',
    color: '#fff',
  },

  statusInactive: {
    background: '#D8000C',
  },

  baseContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '1rem 0',
    padding: '0',

    '& h1': {
      fontFamily: 'Sora',
      fontWeight: '400',
      fontSize: '16px',
      lineHeight: '22px',
      color: '#191C1A',
      marginLeft: '0.5rem',
      marginBottom: '0.25rem',
    },
  },

  logo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem',
    width: '4rem',
    height: '2rem',
  },

  startIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem',
    width: '2rem',
    height: '2rem',
  },

  arrowPlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem !important',
    margin: '0 0.5rem',
    cursor: 'pointer !important',
    transition: 'all 300s ease-in-out',

    '&:hover': {
      color: '#66BB6A',
    },
  },

  arrowPlayDisabled: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem !important',
    margin: '0 0.5rem',
    cursor: 'not-allowed !important',
    opacity: 0.5,
  },

  arrow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'rem !important',
  },

  itemContainer: {
    margin: '0',
    padding: '0',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #E4E4E4',
    borderRadius: '0.5rem',
    backgroundColor: '#F1F1F1',
  },

  item: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: '66px',
    margin: 0,
    borderBottom: '1px solid #E4E4E4',
    padding: '0 1rem',
  },

  itemTable: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: 'auto',
    margin: 0,
    borderBottom: '1px solid #E4E4E4',
    padding: '0.5rem 1rem',
  },

  itemHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '0.25rem',
    width: '40%',
    maxWidth: '40%',
    padding: '0.25rem 0',
  },

  itemStatus: {
    width: '30%',
    maxWidth: '30%',
  },

  itemDate: {
    width: '25%',
    maxWidth: '25%',
    padding: '0.25rem 1rem',
  },

  itemFooter: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '0.25rem',
    width: '5%',
    maxWidth: '5%',
  },

  connectorContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '0.5rem',
  },

  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0rem',
    width: '60%',

    '& section': {
      padding: '0.5rem 0',
      margin: '0.25rem 0',
    },
  },

  divider: {
    width: '100%',
    height: '1px',
    backgroundColor: '#E4E4E4',
    marginTop: '5px',
    marginBottom: '1rem',
  },
}))

export { useStyles }
